import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

// 商城商品（后台列表用）
export interface MallProduct {
  id: number;
  name: string;
  brand: string | null;
  ip: string | null;
  image_url: string;
  price: string;
  mall_stock: number;
  purchase_limit: number;
  is_mall_top: boolean;
  is_presale: boolean;
  is_arrived: boolean;
  arrival_date: string | null;
  arrived_at: string | null;
  presale_payment_mode: string;
  deposit_type: string;
  deposit_amount: string;
  deposit_percent: number;
  sold_count: number;
  updated_at: string;
  updated_by: string | null;
  water_need: number;
  daily_purchase_limit: number;
}

@Module
export default class MallProductModule extends VuexModule {
  mall_products = [] as Array<MallProduct>;
  mall_product_count = 0;

  get currentMallProducts(): Array<MallProduct> {
    return this.mall_products;
  }

  get currentMallProductCount(): number {
    return this.mall_product_count;
  }

  @Mutation
  [Mutations.SET_MALL_PRODUCTS](mall_products) {
    this.mall_products = mall_products;
  }

  @Mutation
  [Mutations.SET_MALL_PRODUCT_COUNT](count) {
    this.mall_product_count = count;
  }

  @Action
  [Actions.GET_MALL_PRODUCTS](params) {
    ApiService.setHeader();

    let queryString = "?";

    if (params) {
      Object.keys(params).forEach((i) => {
        if (params[i] !== undefined && params[i] !== null && params[i] !== "") {
          queryString += "&" + i + "=" + params[i];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/mall_products", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_MALL_PRODUCTS, data["mall_products"]);
          this.context.commit(Mutations.SET_MALL_PRODUCT_COUNT, data["total_result"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || "请求失败");
          reject();
        });
    });
  }

  // 标记预售商品到货：会真实发出用户补款通知，调用方必须先二次确认
  @Action
  [Actions.MARK_PRODUCT_ARRIVED](id) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.post(`admin/products/${id}/mark_arrived`, {})
        .then(({ data }) => {
          if (data && data.success) {
            resolve();
          } else {
            reject(new Error((data && data.error) || "标记到货失败"));
          }
        })
        .catch(({ response }) => {
          reject(new Error(response?.data?.error || "标记到货失败"));
        });
    });
  }
}
